import { Grid, makeStyles } from '@material-ui/core';
import InfinityScroll from 'components/Shared/InfinityScroll';
import { ILesson } from 'interface/course';
import React from 'react';
import Lesson from '../../Lessons/Lesson';
import SearchLessonSkeleton from '../Skeleton';

interface IProps {
  lessons: ILesson[];
  handleEndReached: () => void;
  loading: boolean;
}

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
  },
  container: {
    overflow: 'hidden',
    '@media(max-width: 425px)': {
      padding: theme.spacing(4),
      paddingBottom: 0,
    },
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: theme.spacing(6),
    background: theme.palette.safevideo.main,
    paddingBottom: theme.spacing(2),
  },
}));

const LessonList: React.FC<IProps> = ({ lessons, loading, handleEndReached }) => {
  const classes = useStyles();

  return (
    <Grid>
      <Grid>
        {lessons.length == 0 && loading && (
          <>
            <SearchLessonSkeleton />
            <SearchLessonSkeleton />
            <SearchLessonSkeleton />
            <SearchLessonSkeleton />
          </>
        )}
        <InfinityScroll onScrollToBottom={handleEndReached} bottomDistance={50}>
          {lessons.length >= 1 && (
            <Grid className={classes.container}>
              {lessons.map((lesson) => (
                <Grid key={lesson.id} className={classes.cardContainer}>
                  <Lesson lesson={lesson} blockedModule={false} disableProgress={true} />
                </Grid>
              ))}
            </Grid>
          )}
        </InfinityScroll>
      </Grid>
    </Grid>
  );
};

export default LessonList;
